import { injectReducer } from 'store/reducers'
import { USER_ROLES_WITH_RESTRICTED_ACCESS } from 'utils/constants'
import { UserDoesNotHaveRole, UserIsAuthenticated, UserHasValidPassword, UserHasScope } from 'containers/authContainers'
import TrainingPageContainer from './containers/TrainingPageContainer'
import trainingMaterial, { actions } from './modules/Training'

// Sync route definition
export default store => ({
  exact: true,
  getComponent(nextState, cb) {
    require.ensure(
      [],
      () => {
        const { params } = nextState
        const { studyID } = params

        // Add Reducer
        injectReducer(store, {
          key: 'trainingMaterial',
          reducer: trainingMaterial,
        })

        store.dispatch(actions.fetchTraining(studyID))
        // Return Component
        cb(
          null,
          UserIsAuthenticated(
            UserHasValidPassword(
              UserHasScope(
                ['rs'],
                UserDoesNotHaveRole(USER_ROLES_WITH_RESTRICTED_ACCESS, TrainingPageContainer),
                false,
                studyID,
              ),
            ),
          ),
        )
      },
      'dashboard',
    )
  },
})
